module.exports = __webpack_public_path__ + "static/media/home.de5cf55f.svg";